var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loading-wrapper"},[_c('img',{attrs:{"src":require("../../assets/images/spinner.svg"),"alt":"Loading"}}),_c('span',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }